import React, {useState, useEffect, useRef} from 'react';
import {findEnabledTablesByQueryString, getCompanyByUserUUID} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";

const apiUrl = Config.apiUrl;
// requireComanda: Pedido Comanda sempre pede a comanda depois da mesa, independente do parâmetro da empresa.
const SaleManagerTable = ({requireComanda = false}) => {
        const [tables, setTables] = useState([]);
        const [filteredTables, setFilteredTables] = useState([]);
        const [queryString, setQueryString] = useState('');
        const inputQueryString = useRef(null);
        const [, setLoading] = useRecoilState(loadingAtom);
        const [requireComandaForTable, setRequireComandaForTable] = useState(true);
        const navigate = useNavigate();

        useEffect(() => {
            getCompanyByUserUUID().then((company) => {
                if (company) {
                    setRequireComandaForTable(company.requireComandaForTable !== false);
                    // Empresa não pede mesa no Pedido Comanda: vai direto para a comanda, sem mesa.
                    if (requireComanda && company.showComandaTable === false) {
                        localStorage.setItem('sale', JSON.stringify({orderType: 4}));
                        navigate("/sale/customer", {replace: true});
                    }
                }
            });
        }, []);

        function removeSpecialChars(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }

        async function makeQuery(query) {
            try {
                setLoading(true);
                const tables = await findEnabledTablesByQueryString(query);
                // Ordenar alfabeticamente por nome
                const sortedTables = tables.sort((a, b) => {
                    const nameA = removeSpecialChars(a.name).toUpperCase();
                    const nameB = removeSpecialChars(b.name).toUpperCase();
                    return nameA.localeCompare(nameB);
                });
                setTables(sortedTables);
                setFilteredTables(sortedTables);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        }

        useEffect(() => {
            if (inputQueryString.current) {
                inputQueryString.current.focus();
            }
            makeQuery('');
        }, []);

        useEffect(() => {
            const filtered = tables.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(queryString));
            // Manter ordenação alfabética após filtrar
            const sortedFiltered = filtered.sort((a, b) => {
                const nameA = removeSpecialChars(a.name).toUpperCase();
                const nameB = removeSpecialChars(b.name).toUpperCase();
                return nameA.localeCompare(nameB);
            });
            setFilteredTables(sortedFiltered);
        }, [queryString, tables]);

        const handleInputChange = (e) => {
            const string = removeSpecialChars(e.target.value).toUpperCase();
            const filtered = tables.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(string));
            // Manter ordenação alfabética após filtrar
            const sortedFiltered = filtered.sort((a, b) => {
                const nameA = removeSpecialChars(a.name).toUpperCase();
                const nameB = removeSpecialChars(b.name).toUpperCase();
                return nameA.localeCompare(nameB);
            });
            setFilteredTables(sortedFiltered);
            setQueryString(string);
        };

        return (
            <>
                <div className="header-label">Mesa</div>

                <div
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                    className="input-container">
                    <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                           onChange={handleInputChange} onFocus={(event) => event.target.select()} inputMode="numeric"/>
                    <button id="clearButton" onClick={() => {
                        setQueryString('');
                        inputQueryString.current.focus();
                    }}>X
                    </button>
                </div>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '500px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>
                            Nome
                        </th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredTables.map((table, index) => (
                        <tr key={index}>
                            <td>
                                <div key={index}>{table.name}</div>
                            </td>
                            <td>
                                <button onClick={async () => {
                                    // Pedido Comanda tem fila de impressão própria (Sale.ORDER_TYPE_COMANDA = 4).
                                    const sale = requireComanda ? {table: table, orderType: 4} : {table: table};
                                    localStorage.setItem('sale', JSON.stringify(sale));
                                    navigate(requireComanda || requireComandaForTable ? "/sale/customer" : "/sale/items");
                                }}>Selecionar
                                </button>
                            </td>

                        </tr>
                    ))}
                    </tbody>
                    {tables.length === 0 &&
                        <tfoot>
                        <tr>
                            <td colSpan={5}>
                                Nenhum item encontrado
                            </td>
                        </tr>
                        </tfoot>
                    }
                </table>
            </>
        );
    }
;

export default SaleManagerTable;
